/** Matriz de ICMS em vigor (substitui a aba ICMS da planilha). Somente leitura nesta etapa. */
import { Datagrid, List, SelectInput, TextField } from "react-admin";
import Alert from "@mui/material/Alert";
import { CampoData, CampoPercentual } from "../componentes";

const ufs = [
  "AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA",
  "PB", "PR", "PE", "PI", "RN", "RS", "RJ", "RO", "RR", "SC", "SP", "SE", "TO",
].map((uf) => ({ id: uf, name: uf }));

const filtros = [
  <SelectInput key="destino" source="uf_destino" choices={ufs} alwaysOn />,
  <SelectInput key="origem" source="uf_origem" choices={ufs} alwaysOn />,
];

export function AliquotaIcmsLista() {
  return (
    <List
      title="Matriz de ICMS"
      filters={filtros}
      filterDefaultValues={{ uf_destino: "SE" }}
      sort={{ field: "uf_origem", order: "ASC" }}
      perPage={50}
      actions={false}
    >
      <Alert severity="info" sx={{ mb: 2 }}>
        Quando origem = destino, o valor é a alíquota interna do estado (com FECEP). Fora disso, é a alíquota
        interestadual. Copiada da planilha; só a interna de SE e as interestaduais com destino SE foram conferidas
        contra a lei.
      </Alert>
      <Datagrid bulkActionButtons={false} rowClick={false}>
        <TextField source="uf_origem" />
        <TextField source="uf_destino" />
        <CampoPercentual source="aliquota" />
        <CampoData source="vigente_desde" />
      </Datagrid>
    </List>
  );
}
